import { AccessToken } from './access.token';
import { GeneralResponseMessage } from '../messages/general.response.message';
import { RefreshToken } from './refresh.token';

export class UserToken {
  UserId: number;
  UserName: string;
  IpAddress: string;
  Location: string;
  Role: string;
  AccessToken: AccessToken;
  Messages: GeneralResponseMessage[] | null;
  RefreshToken: RefreshToken | null;

  // for MFA
  MfaInfo: GeneralResponseMessage;
  DeviceCode: string;
  DeviceName: string;
  VerificationCode: string;
  IsRequiredToAddMFA: boolean;

  constructor() {
    this.Messages = [];
  }
}

export class PaUserToken extends UserToken {
  MasterEmail: string;
  InternalGroupId: number;
  IsPaLogin: boolean;
  PaUserId: number;

  constructor() {
    super();
    this.IsPaLogin = false;
    this.PaUserId = null;
    this.MasterEmail = '';
  }
}
